// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12":"572a748f","394":"74f22869","976":"e4dfe8ee"}[chunkId] + ".chunk.css";
};